// src/store/useAuthStore.ts
import { create } from "zustand";

interface AuthStore {
  supportCount: boolean;
  setSupportCount: (supportCount: boolean) => void;
  reviewCount: boolean;
  setReviewCount: (reviewCount: boolean) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  supportCount: false,
  setSupportCount: (supportCount) => {
    set({ supportCount });
  },
  reviewCount: false,
  setReviewCount: (reviewCount) => {
    set({ reviewCount });
  },
}));
